/*
sign-up-i18n.js

-GE CONFIDENTIAL-
Type: Source Code

Copyright (c) 2021, GE Healthcare Co.
All Rights Reserved

This unpublished material is proprietary to GE Healthcare. The methods and
techniques described herein are considered trade secrets and/or
confidential. Reproduction or distribution, in whole or in part, is
forbidden except by express written permission of GE Healthcare.
*/
define('login/modules/sign-up/services/sign-up-i18n',['angular', 'messages'], function () {

    // Modyle Dependencies
    var dependencies = [
        'Services.Messages'
    ];

    // Module Creation
    var mod = angular.module('SignUp.Services.i18n', dependencies);

    /**
     * @name LoginNavbar.i18n
     * @type factory
     *
     * @description
     * A factory that provides i18n messages for the 'Login' page's navigation bar.
     */
    mod.factory('SignUp.i18n', ['messages', function (messages) {
        /**
         * Gets all messages for the 'Login' page's navigation bar.
         */
        function getMessages() {
            return {
                dontHaveAnAccount: messages.get('dontHaveAnAccount'),
                signUp: messages.get('signUp'),
                selectOrganization: messages.get('selectOrganization'),
                signInWithSSO: messages.get('signInWithSSO')
            };
        }

        // Public API
        return {
            getMessages: getMessages
        };

    }]);

});

